import { Template, LazyTemplate } from "../../core/template/index";
import { View } from "../../core/view";
import ConfirmModal from "../../core/modals/confirm/index";
import  Order, { OrderLike } from "../../app/db/models/order";
import { ForeignKey, User } from "../../core/db/models";
import { LogisticsProvider } from "../../app/db/models/index";
import OrderItem, { OrderItemLike } from "../../app/db/models/orderItem";
import { ModalResultType } from "../../core/modal/index";
import { ClientAction } from "../../app/synchronizer";
import { ValtasiirtoBaseApp } from "../../app/valtaSiirtoBaseApp";
import AddOrderImageModal from "../../modals/addOrderImage";
import MessageModal from "../../core/modals/message";

export default class OrderFlipcardView extends View
{
    public template = Template.lazy('/views/orderFlipcard/index.html');   
    public app: ValtasiirtoBaseApp;
    public data: OrderFlipcardViewData;
    private takeButton: HTMLButtonElement;
    private cancelButton: HTMLButtonElement;
    private completedButton: HTMLButtonElement;
    private imagesButton: HTMLButtonElement;

    constructor(data)
    {
        super(data);
    }

    private getAssignedUsernames()
    {
        return this.data.assignments.map(o => (o.user as User).username);
    }

    private get isToggled(): boolean
    {
        if (this.data.state === Order.STATE_ASSIGNED)
        {
            return this.data.items.find(o => o.state !== OrderItem.STATE_COMPLETED) == null;
        }

        return false;
    }

    public beforeRender(): PromiseLike<void>
    {
        this.data.isAssignedToCurrentUser = this.data.assignments.find(o => o.user_id == this.app.user.id) != null;
        this.data.canBeAssigned = this.data.state === Order.STATE_AVAILABLE || (this.data.state === Order.STATE_ASSIGNED && !this.data.isAssignedToCurrentUser);
        this.data.canBeCompleted = this.data.items.find(o => o.state != OrderItem.STATE_COMPLETED) == null;
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {
        this.takeButton = this.element.querySelector('#takeOrJoinOrder') as HTMLButtonElement;
        this.cancelButton = this.element.querySelector('#cancelOrder') as HTMLButtonElement;
        this.completedButton = this.element.querySelector('#orderCompleted') as HTMLButtonElement;
        this.imagesButton = this.element.querySelector('#orderImages') as HTMLButtonElement;
        return super.afterRender();
    }

    public onAssignButtonClick(e: MouseEvent)
    {
        this.helpers.setButtonEnabled(this.takeButton, false);
        e.stopPropagation();
        
        let modal = new ConfirmModal(this.pgettext('Order message', 'Are you sure you want to assign this order to yourself?'));

        this.app.actions.confirmAndPush(modal, {
            action: ClientAction.ORDER_ASSIGN_USER,
            data: {
                user_id: this.app.user.id,
                order_id: this.data.id
            }
        }, false).then(() =>
        {
            this.app.toasts.show(this.pgettext('Order message', 'Order successfully assigned!'));
            location.hash = '#/order-items/';
        }, () => 
        {  
            this.helpers.setButtonEnabled(this.takeButton, true);
        });
    }

    public onCancelButtonClick(e: MouseEvent)
    {
        this.helpers.setButtonEnabled(this.cancelButton, false);
        e.stopPropagation();
        
        let modal = new ConfirmModal(this.pgettext('Order message', 'Are you sure you want to cancel assigning yourself?'));
        this.app.actions.confirmAndPush(modal, {
            action: ClientAction.ORDER_CANCEL_ASSIGN_USER,
            data: {
                user_id: this.app.user.id,
                order_id: this.data.id
            }
        }).then(() => 
        {
            this.app.toasts.show(this.pgettext('Order message', 'Order assignment successfully cancelled!'));
        }, () => { this.helpers.setButtonEnabled(this.cancelButton, true)});
    }

    public onCompleteButtonClick(e: MouseEvent)
    {
        this.helpers.setButtonEnabled(this.completedButton, false);
        e.stopPropagation();
        let modal = new ConfirmModal(this.pgettext('Order message', 'Are you sure you want to mark this order as completed?'));
        this.app.actions.confirmAndPush(modal, {
            action: ClientAction.ORDER_COMPLETE,
            data: {
                user_id: this.app.user.id,
                order_id: this.data.id
            }
        }).then(() => 
        {
            this.app.toasts.show(this.pgettext('Order message', 'Order assignment successfully completed!'));
        }, () => { this.helpers.setButtonEnabled(this.completedButton, true)});
    }

    public onMoveToOrderItemsClick(e: MouseEvent)
    {
        e.stopPropagation();
        
        location.hash = '#/order-items/';
    }

    public onOrderImagesButtonClick(e: MouseEvent)
    {
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.helpers.setButtonEnabled(this.imagesButton, false);

        let modal = new AddOrderImageModal(
            this.app.pgettext('Order', 'Add image'),
            '',
            this.data
        );

        this.app.modals.show(modal).then(() =>
        {
            this.helpers.setButtonEnabled(this.imagesButton, true);
        });
    }

    public onOrderInternalMessageButtonClick(e: MouseEvent) {
        e.preventDefault();
        e.stopPropagation();

        const modal = new MessageModal(
            this.data.internal_message,
            this.pgettext('Order', 'Internal message'),
        );

        this.app.modals.show(modal);
    }
}

export interface OrderFlipcardViewData extends OrderLike
{
    isAssignedToCurrentUser?: boolean;
    canBeAssigned?: boolean;
    canBeCompleted?: boolean;
}